import React from 'react';
import {Image} from './Image';
import {ButtonButton} from './ButtonButton';
import DataPages from './API_Pages';

const __Page = (props) => {
  var pageName = props.match.params.pageName;
  var videoId = DataPages.all().filter((e) => e.name === pageName).map(e => e.video);
  var videoTime = DataPages.all().filter((e) => e.name === pageName).map(e => e.video_time);
  var videoLink = "";
  var hidden = "";
  var imageClass = "image-big";

  if (videoId[0]) {
    videoLink = "https://youtu.be/" + videoId + "?t=" + videoTime;
  } else {
    hidden = "hidden";
  }

  if (pageName === "Jungle") {
    imageClass = "image-big image-big--jungle";
  }

  if (pageName === "Dogy_2") {
    imageClass = "image-big image-big--dogy";
  }

  return (
    <div className="content fading">
      <h1>{pageName}</h1>
      {/* <p className="subtitle">Here you put some description</p> */}
      <section>
        <Image
          type="page"
          class={imageClass}
          id={pageName}></Image>
        <div className={"subtitle " + hidden}>You can find this page in action on this <a target="_blank" href={videoLink}>video</a></div>
        <ButtonButton align="centered" buttonText="Go back to the list of all" buttonLink="Pages" history={pageName} idNumber="2" />
      </section>
    </div>
  )
}

export default __Page;



// WEBPACK FOOTER //
// ./src/components/__Page.js